import { v4 } from 'uuid';

import { createFaviconUrl } from '~/views/alfred/research/utils/createFaviconUrl';

export interface WebsiteInfo {
  id: string;
  title: string;
  url: string;
  favicon: string;
}

export const formatWebsiteInfo = (urls: string[]) =>
  urls.map(source => ({
    id: v4(),
    title: '',
    url: source,
    favicon: createFaviconUrl(source, 24),
  }));
